var parent = require('../../actual/object/get-own-property-descriptors');

module.exports = parent;
